import { render, staticRenderFns } from "./import-custom-luts.vue?vue&type=template&id=80e9bc66&"
import script from "./import-custom-luts.vue?vue&type=script&lang=js&"
export * from "./import-custom-luts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports